/** zh-CN catalogue `extra` (W3-09; English: src/formats/extra/extra.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'extra',
  locale: 'zh-CN',
  messages: {
    'report.invalidUtf8': 'extra.json 不是有效的 UTF-8 文本。仍已读取；但 Phira 会因此无法加载谱面。',
    'report.bom': 'extra.json 以字节顺序标记（BOM）开头。已忽略它；但 Phira 会因此无法加载谱面。',
    'report.syntax':
      'extra.json 不是有效的 JSON（第 {line} 行第 {col} 列）。已略去其中的特效和视频；Phira 会因此无法加载谱面。',
    'report.notObject': 'extra.json 不包含 JSON 对象。已略去其内容；Phira 会因此无法加载谱面。',
    'report.missingBpm': 'extra.json 缺少 Phira 必需的“bpm”字段。已使用谱面的 BPM；Phira 会因此无法加载谱面。',
    'report.duplicateKey': '字段“{field}”写了两次，已使用最后一个值。Phira 会因此无法加载谱面。',
    'report.wrongType': '字段“{field}”的值类型错误，已略去。Phira 会因此无法加载谱面。',
    'report.missingField': '缺少必需字段“{field}”，已略去该项。Phira 会因此无法加载谱面。',
    'report.floatInTriple': '“{field}”中的一个拍数使用了带小数点的数字。已取整；Phira 会因此无法加载谱面。',
    'report.floatInInt': '“{field}”必须是整数。已取整；Phira 会因此无法加载谱面。',
    'report.tripleRange': '“{field}”中的一个拍数有部分超出范围。已更正；Phira 会因此无法加载谱面。',
    'report.outOfRange': '“{field}”中的数字过大。已略去该项；Phira 会因此无法加载谱面。',
    'report.colourNotBytes': '颜色“{field}”必须是四个 0 到 255 之间的整数。已转换；Phira 会因此无法加载谱面。',
    'report.varShape': '“{field}”的值既不是数字、数对、颜色，也不是关键帧列表。已略去；Phira 会因此无法加载谱面。',
    'report.emptyKeyframes': '“{field}”的关键帧列表为空，这会使 Phira 崩溃。已略去。',
    'report.unknownShader':
      '“{name}”不是 Phira 的内置着色器，而自定义着色器路径必须以“/”开头。已略去该特效；Phira 会因此无法加载谱面。',
    'report.shaderPath': '着色器路径“{name}”没有指向任何文件。已略去该特效；Phira 会因此无法加载谱面。',
    'report.videoScale':
      '视频缩放方式“{value}”不是 cropCenter、inside 或 fit 之一。已使用 cropCenter；Phira 会因此无法加载谱面。',
    'report.tripleZeroDen': '“{field}”中的一个拍数除以零，Phira 无法定位它。已略去该项。',
    'report.invalidBpm': 'extra.json 的 BPM 列表中有一个值不是正数。已用谱面的 BPM 计算其时间。',
    'report.bpmConverted':
      'extra.json 有自己的 BPM 列表。已有 {count} 个时间经过秒数换算为谱面拍数，使特效和视频保持在相同的时刻。',
    'report.bpmInexact': '部分 extra.json 时间无法用谱面拍数精确表示，已取整。',
    'report.timeOutOfRange': '部分 extra.json 时间换算为谱面拍数后离谱面开头太远，已移到编辑器支持的最近拍数。',
    'report.duplicateVar': '特效变量“{field}”写了两次，已像 Phira 一样使用最后一个值。',
    'report.keyframeKeyDropped': 'extra.json 中的关键帧不能包含“{field}”；Phira 会忽略它，因此已略去。',
    'report.videoLeadIn':
      '视频的 {field} 关键帧从 extra.json BPM 列表的第 0 拍开始，而该列表在第 0 拍之前就已开始。Phira 会把第一个关键帧向前延续到谱面开头；现在谱面在第一个关键帧之前显示默认的 {field}。',
    'report.keyframesUnsorted':
      '“{field}”的关键帧没有按时间顺序排列。已保留它们，并按 Phira 正向播放的方式播放；向后跳转后，在重新开始谱面之前 Phira 可能显示其他数值。',
    'report.effectNeverActive': '一个特效在开始之前就结束了，因此永远不会显示。',
  },
};

export default catalog;
